import { FC } from 'react'

import { Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer'

import { DownloadPdfButtonProps } from 'src/Pages/Calculator/DownloadPdfButton.tsx'
import CheckIcon from 'src/Assets/check.png'
import UncheckIcon from 'src/Assets/uncheck.png'
import IG from 'src/Assets/QR/IG.png'
import TG from 'src/Assets/QR/TG.png'
import SiteUrl from 'src/Assets/QR/url.png'
import { colors } from 'src/Helpers/constants.ts'

const includedExpensesData = [
  'Амортизационные отчисления оборудования',
  'Эксплуатацию, техническое обслуживание и инспекции',
  'Текущий и капитальный ремонт ТС, запасные части и расходные материалы',
  'Мойку и чистку, размещение ТС в гараже и/или затраты на парковку',
  'Внутренний трехэтапный отбор машинистов техники для качественного оказания услуг',
  'Расходы на оплату труда операторов',
  'Расходы на проезд операторов до места выполнения работ и обратно',
  'Меры по охране труда',
]

const styles = StyleSheet.create({
  page: {
    padding: 39,
    paddingLeft: 78,
    fontFamily: 'Geometria',
    fontSize: 10,
    color: '#333',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  sectionTitle: {
    fontFamily: 'Geometria',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 15,
  },
  listItem: { flexDirection: 'row' },
  listBullet: { width: 15, fontFamily: 'Geometria', textAlign: 'center' },
  listText: { flex: 1 },
  bold: {
    fontWeight: 'bold',
  },
  h1: {
    fontFamily: 'Geometria',
    fontSize: 16,
    fontWeight: 600,
    color: colors.mainBlue,
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  horizontalLineBlue: {
    width: '100%',
    height: 1,
    backgroundColor: colors.mainBlue,
  },
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
  qr: {
    width: 50,
  },
  qrWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 60,
  },
})

interface AdditionInfoPageProps {
  validityDaysCount?: DownloadPdfButtonProps['validityDaysCount']
  isWorkService?: DownloadPdfButtonProps['isWorkService']
  medicalExamination?: DownloadPdfButtonProps['withoutMedicalExamination']
  personalBenefits?: DownloadPdfButtonProps['personalBenefits']
  privilegesData?: DownloadPdfButtonProps['privilegesData']
  firstName: DownloadPdfButtonProps['firstName']
  lastName: DownloadPdfButtonProps['lastName']
  email: DownloadPdfButtonProps['email']
  phone: DownloadPdfButtonProps['phone']
  isMobDemob?: DownloadPdfButtonProps['isMobDemob']
}

export const AdditionInfoPage: FC<AdditionInfoPageProps> = ({
  validityDaysCount,
  isWorkService,
  medicalExamination,
  personalBenefits,
  privilegesData,
  firstName,
  lastName,
  email,
  phone,
}) => {
  const otherConditionsData = [
    {
      text: 'Выполнение требований законодательства и нормативных правовых актов, в том числе в области санитарной и эпидемиологической безопасности, проведение инструктажей',
      checked: true,
    },
    {
      text: 'Расходы по получению и поддержанию в силе любой разрешительной документации, необходимой для оказания услуг',
      checked: true,
    },
    {
      text: 'Командировочные расходы, расходы на страхование техники и персонала, предусмотренные законодательством РФ налоги и сборы',
      checked: true,
    },
    { text: 'Электронный документооборот', checked: true },
    { text: 'Обеспечение нормальных условий труда', checked: isWorkService },
    {
      text: 'Медицинское освидетельствование водителей',
      checked: medicalExamination,
    },
    { text: 'Банковские проценты', checked: false },
  ]

  return (
    <Page size='A4' style={styles.page}>
      <View>
        {personalBenefits && (
          <View style={styles.tableWrapper}>
            <View style={styles.titleWrapper}>
              <Text style={styles.h1}>Персональные привилегии</Text>
              <View style={styles.horizontalLineBlue}></View>
            </View>

            <View>
              {privilegesData?.map((item, index) => (
                <View key={index} style={styles.listItem}>
                  {/*<Text style={styles.listBullet}>➔</Text>*/}
                  <Text style={styles.listText}>{item}</Text>
                </View>
              ))}
            </View>
          </View>
        )}
      </View>
      <View style={styles.tableWrapper}>
        <View style={styles.titleWrapper}>
          <Text style={styles.h1}>
            В аренду включены следующие статьи расходов
          </Text>
          <View style={styles.horizontalLineBlue}></View>
        </View>
        <View>
          {includedExpensesData.map((item, index) => (
            <View key={index} style={styles.listItem}>
              <Text style={styles.listBullet}>
                <Image src={CheckIcon} />
              </Text>
              <Text style={styles.listText}>{item}</Text>
            </View>
          ))}
        </View>

        <View>
          {otherConditionsData.map((item, index) => (
            <View key={index} style={styles.listItem}>
              <Text style={styles.listBullet}>
                {item.checked ? (
                  <Image src={CheckIcon} />
                ) : (
                  <Image src={UncheckIcon} />
                )}
              </Text>
              <Text style={styles.listText}>{item.text}</Text>
            </View>
          ))}
        </View>
      </View>
      <View style={{ marginTop: 'auto' }}>
        <Text>
          Арендатор полностью несет ответственность за выбор техники и
          соответствие ее технических характеристик для запланированных работ
        </Text>
        <Text>{`Предложение действительно в течение ${validityDaysCount} дней с даты отправки.`}</Text>
      </View>

      <View style={styles.titleWrapper}>
        <Text style={styles.h1}>Контактные данные</Text>
        <View style={styles.horizontalLineBlue}></View>
      </View>
      <View>
        <Text>{`${firstName} ${lastName}`}</Text>
        <Text>{`Тел:     ${phone}`}</Text>
        <Text>Email: {email}</Text>
      </View>
      <View style={styles.qrWrapper}>
        <Image style={styles.qr} src={IG} />
        <Image style={styles.qr} src={SiteUrl} />
        <Image style={styles.qr} src={TG} />
      </View>
    </Page>
  )
}
